import { Route } from 'react-router-dom';
import Subscribers from '../Pages/Subscribers/Subscribers';
import Layout from '../components/layout';
import EditSubscriber from '../Pages/Subscribers/EditSubscriber';
import ProtectedRoute from '../components/ProtectedRoute';

export const SubscriberRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/subscribers" element={
      <ProtectedRoute>
        <Layout activePage='subscribers' menuActive={menuActive} setMenuActive={setMenuActive}>
          <Subscribers />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/subscriber/:id" element={
      <ProtectedRoute>
        <Layout activePage='edit-subscriber' menuActive={menuActive} setMenuActive={setMenuActive}>
          <EditSubscriber />
        </Layout>
      </ProtectedRoute>
    } />
  </>
);
